module.exports = __webpack_public_path__ + "img/cend2.f2b766f.png";